import React from 'react';
import { Link } from 'react-router-dom';
import SharedNavbar from '../components/SharedNavbar';
import './DMBoK3Page.css';

const DMBoK3Page = () => {
  return (
    <div className="dmbok3-page">
      <SharedNavbar />

      {/* ===== HERO ===== */}
      <section className="dmbok3-hero">
        <div className="dmbok3-hero-content">
          <h1>DMBOK® 3</h1>
          <div className="dmbok3-hex-row">
            <div className="dmbok3-hex hex-white"></div>
            <div className="dmbok3-hex hex-light"></div>
            <div className="dmbok3-hex hex-mid"></div>
            <div className="dmbok3-hex hex-lavender"></div>
            <div className="dmbok3-hex hex-dark"></div>
          </div>
        </div>
      </section>

      {/* ===== INTRO ===== */}
      <section className="dmbok3-intro">
        <div className="dmbok3-container">
          <p>
            DAMA International is developing <strong>DMBoK® 3.0</strong>, the next evolution
            of the Data Management Body of Knowledge.
          </p>
          <p>
            This page will help DAMA Tunisia members keep up to date with the project,
            including official information, webinar progress updates, and any future
            opportunities that may be relevant to the Tunisian data management community.
          </p>
        </div>
      </section>

      {/* ===== MAIN TEAL SECTION ===== */}
      <section className="dmbok3-main">
        <div className="dmbok3-container">
          <div className="dmbok3-tag">DAMA Tunisia • DAMA-DMBOK® 3.0</div>
          <div className="dmbok3-body">

            {/* LEFT */}
            <div className="dmbok3-left">
              <h2 className="dmbok3-title">
                Shaping the Future of<br />Data Management Together
              </h2>
              <p className="dmbok3-text">
                DAMA International is evolving to stay at the forefront of data management.
                The DAMA-DMBOK® 3.0 project is designed to be vibrant, relevant, and built
                collaboratively through transparent governance, structured contribution,
                and meaningful global engagement.
              </p>
              <p className="dmbok3-text">
                With a clear operating model, defined responsibilities, and active
                participation from the worldwide data community, the project is being
                developed to serve professionals, educators, and practitioners for years to come.
              </p>
              <div className="dmbok3-buttons">
                <a
                  href="https://dama.org/dama-dmbok-3-0-project/"
                  target="_blank"
                  rel="noreferrer"
                  className="dmbok3-btn-primary"
                >
                  Visit the DMBoK® 3 Project Page
                </a>
                <a
                  href="https://www.damadmbok.org/events"
                  target="_blank"
                  rel="noreferrer"
                  className="dmbok3-btn-secondary"
                >
                  View Webinar Progress Updates
                </a>
              </div>
            </div>

            {/* RIGHT card */}
            <div className="dmbok3-right">
              <div className="dmbok3-card">
                <h4>Why clear governance matters</h4>
                <p>
                  Writing a reference book with over 100 volunteers wanting to directly
                  contribute is practically impossible without structure. The Triple Helix
                  governance model creates clarity, focus, accountability, and trust across
                  the full DAMA-DMBOK® 3.0 development journey.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ===== FOR DAMA TUNISIA MEMBERS ===== */}
      <section className="dmbok3-members-section">
        <div className="dmbok3-container">
          <div className="dmbok3-members-box">
            <h3>For DAMA Tunisia Members</h3>
            <p>
              We will share any Tunisia-specific updates, opportunities and relevant
              announcements here as the DMBoK® 3.0 project progresses.
            </p>
          </div>
        </div>
      </section>

      {/* ===== 3 CTA ===== */}
      <section className="dmbok3-cta">
        <div className="dmbok3-container">
          <div className="dmbok3-cta-grid">
            <Link to="/membership" className="dmbok3-cta-btn">
              <strong>Become a member</strong>
              <span>Join today and access all our resources</span>
            </Link>
            <Link to="/events" className="dmbok3-cta-btn">
              <strong>Events</strong>
              <span>Discover upcoming and past events</span>
            </Link>
            <Link to="/about" className="dmbok3-cta-btn">
              <strong>Sponsor us</strong>
              <span>Connect with the Tunisian data community</span>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default DMBoK3Page;